import PressCDNDescription from "../../../../src/courses/partials/services/presscdn.mdx";
import * as React from 'react';
export default {
  PressCDNDescription,
  React
};